import { t } from '@lingui/core/macro';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { OrganizationDetailsForm } from '../-components/organization-details-form';
import { organizationDetailsQueryOptions } from '../-utils/organization-settings-query';
import {
  SettingsSection,
  SettingsSectionSkeleton,
} from '../../settings/-components/settings-section';
import { SETTINGS_HELP } from '../../settings/-utils/help-articles';

export const Route = createFileRoute(
  '/researchers/_authenticated/organization-settings/organization/details',
)({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(
      organizationDetailsQueryOptions(
        context.activeDashboard.organization ?? '',
      ),
    ),
  pendingComponent: SettingsSectionSkeleton,
  component: OrganizationDetailsPage,
  head: () => ({ meta: [{ title: t`Organization details` }] }),
});

function OrganizationDetailsPage() {
  const { activeDashboard } = Route.useRouteContext();
  const { data: details } = useSuspenseQuery(
    organizationDetailsQueryOptions(activeDashboard.organization ?? ''),
  );
  return (
    <SettingsSection
      title={t`Organization details`}
      description={t`Your organization's name, address and receipt details.`}
      helpUrl={SETTINGS_HELP.teams}
    >
      <OrganizationDetailsForm key={details.organizationId} details={details} />
    </SettingsSection>
  );
}
